'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var styles = require('@material-ui/styles');
var Typography = require('@material-ui/core/Typography');
var TableCell = require('@material-ui/core/TableCell');
var TableRow = require('@material-ui/core/TableRow');
var CircleLoader = require('genjo-ui/core/CircleLoader');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);
var TableCell__default = /*#__PURE__*/_interopDefaultLegacy(TableCell);
var TableRow__default = /*#__PURE__*/_interopDefaultLegacy(TableRow);
var CircleLoader__default = /*#__PURE__*/_interopDefaultLegacy(CircleLoader);

var useStyles = styles.makeStyles({
  container: {
    height: 200,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }
});
var TableResultsLoader = _ref => {
  var {
    colSpan = 1,
    isLoading,
    count = 0,
    children = 'No Results'
  } = _ref;
  var classes = useStyles();

  if (!isLoading && count) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement(TableRow__default['default'], null, /*#__PURE__*/React__default['default'].createElement(TableCell__default['default'], {
    colSpan: colSpan,
    className: classes.root
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.container
  }, isLoading ? /*#__PURE__*/React__default['default'].createElement(CircleLoader__default['default'], null) : typeof children === 'string' ? /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
    variant: "h6",
    color: "textSecondary"
  }, children) : children)));
};
TableResultsLoader.propTypes = {
  /** If `true` the loading circle will appear. */
  isLoading: index.bool,

  /** The number of records in the results. */
  count: index.number,

  /** The number of columns in the table. */
  colSpan: index.number,

  /** Content to render when the loaded count is zero. */
  children: index.node
};

exports.TableResultsLoader = TableResultsLoader;
